import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import { streamCollector } from "@smithy/fetch-http-handler";
import { toBase64 } from "@smithy/util-base64";
import { toHex } from "@smithy/util-hex-encoding";
import { toUtf8 } from "@smithy/util-utf8";
import { isReadableStream } from "./stream-type-check";
var ERR_MSG_STREAM_HAS_BEEN_TRANSFORMED = "The stream has already been transformed.";
export var sdkStreamMixin = function sdkStreamMixin(stream) {
  if (!isBlobInstance(stream) && !isReadableStream(stream)) {
    var _stream$__proto__, _stream$__proto__$con;
    var name = (stream === null || stream === void 0 ? void 0 : (_stream$__proto__ = stream.__proto__) === null || _stream$__proto__ === void 0 ? void 0 : (_stream$__proto__$con = _stream$__proto__.constructor) === null || _stream$__proto__$con === void 0 ? void 0 : _stream$__proto__$con.name) || stream;
    throw new Error("Unexpected stream implementation, expect Blob or ReadableStream, got ".concat(name));
  }
  var transformed = false;
  var transformToByteArray = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!transformed) {
                _context.next = 2;
                break;
              }
              throw new Error(ERR_MSG_STREAM_HAS_BEEN_TRANSFORMED);
            case 2:
              transformed = true;
              _context.next = 5;
              return streamCollector(stream);
            case 5:
              return _context.abrupt("return", _context.sent);
            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function transformToByteArray() {
      return _ref.apply(this, arguments);
    };
  }();
  var blobToWebStream = function blobToWebStream(blob) {
    if (typeof blob.stream !== "function") {
      throw new Error("Cannot transform payload Blob to web stream. Please make sure the Blob.stream() is polyfilled.\n" + "If you are using React Native, this API is not yet supported, see: https://react-native.canny.io/feature-requests/p/fetch-streaming-body");
    }
    return blob.stream();
  };
  return Object.assign(stream, {
    transformToByteArray: transformToByteArray,
    transformToString: function () {
      var _transformToString = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(encoding) {
        var buf;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return transformToByteArray();
              case 2:
                buf = _context2.sent;
                if (!(encoding === "base64")) {
                  _context2.next = 7;
                  break;
                }
                return _context2.abrupt("return", toBase64(buf));
              case 7:
                if (!(encoding === "hex")) {
                  _context2.next = 11;
                  break;
                }
                return _context2.abrupt("return", toHex(buf));
              case 11:
                if (!(encoding === undefined || encoding === "utf8" || encoding === "utf-8")) {
                  _context2.next = 15;
                  break;
                }
                return _context2.abrupt("return", toUtf8(buf));
              case 15:
                if (!(typeof TextDecoder === "function")) {
                  _context2.next = 19;
                  break;
                }
                return _context2.abrupt("return", new TextDecoder(encoding).decode(buf));
              case 19:
                throw new Error("TextDecoder is not available, please make sure polyfill is provided.");
              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      function transformToString(_x) {
        return _transformToString.apply(this, arguments);
      }
      return transformToString;
    }(),
    transformToWebStream: function transformToWebStream() {
      if (transformed) {
        throw new Error(ERR_MSG_STREAM_HAS_BEEN_TRANSFORMED);
      }
      transformed = true;
      if (isBlobInstance(stream)) {
        return blobToWebStream(stream);
      } else if (isReadableStream(stream)) {
        return stream;
      } else {
        throw new Error("Cannot transform payload to web stream, got ".concat(stream));
      }
    }
  });
};
var isBlobInstance = function isBlobInstance(stream) {
  return typeof Blob === "function" && stream instanceof Blob;
};